export default __webpack_public_path__ + "images/QT.b314ba6.png";